<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Reset Account Password</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section pt-2">
      <div class="container">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <template v-if="!loading">
                    <div class="grid">
                      <div class="col-12">
                        <form
                          ref="observer"
                          tag="form"
                          @submit.prevent="startRecordUpdate()"
                          class=""
                        >
                          <div class="text-lg text-caption text-grey">
                            A new Password will be generated and sent to user's
                            email - {{ formData.email }}
                          </div>
                          <div class="text-center mt-4">
                            <Button
                              type="submit"
                              label="Send New Password"
                              class="p-button-rounded px-4 py-3"
                              icon="pi pi-send"
                              :loading="saving"
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import fileSvgPage from "../custom/file_svg.vue";
import { PageMixin } from "../../mixins/page.js";
import { EditPageMixin } from "../../mixins/editpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "resetpasswordInstitutionaccountsPage",
  components: { fileSvgPage },
  mixins: [PageMixin, EditPageMixin],
  props: {
    pageName: {
      type: String,
      default: "institution_accounts",
    },
    idName: {
      type: String,
      default: "institution_id",
    },
    routeName: {
      type: String,
      default: "institution_accountsresetpassword",
    },
    pagePath: {
      type: String,
      default: "institution_accounts/resetpassword",
    },
    apiPath: {
      type: String,
      default: "institution_accounts/resetpassword",
    },
  },
  data() {
    return {
      formData: {},
      submitted: false,
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Reset Account Password";
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["institution_accounts/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("institution_accounts/setCurrentRecord", value);
      },
    },
  },
  validations() {
    let formData = {};
    return { formData };
  },
  methods: {
    ...mapActions("institution_accounts", ["updateRecord", "fetchRecord"]),
    async startRecordUpdate() {
      this.submitted = true;
      const isFormValid = !this.v$.$invalid;
      if (!isFormValid) {
        this.flashMsg("Please complete the form", "Form is invalid", "error");
        return;
      }
      this.saving = true;
      let id = this.id;
      let url = this.apiUrl;
      let payload = this.normalizedFormData();
      let data = { id, url, payload };
      this.updateRecord(data).then(
        (response) => {
          this.saving = false;
          this.flashMsg(this.msgAfterUpdate);
          this.resetForm();
          this.closeDialogs(); // close page dialog that if opened
          if (this.redirect) this.navigateTo(`/institution_accounts`);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    updateFormFields: function () {
      //update form fields value after load from api
      //e.g convert fieldvalue (value,value2,value2) to array
    },
    resetForm() {
      //reset form fields value
      this.formData = {};
      //raise event to reset other custom form components
      //this.$EventBus.$emit("resetForm");
    },
    getErrorClass(field) {
      if (this.v$.formData[field].$invalid && this.submitted) {
        return "p-invalid";
      }
      return "";
    },
  },
  watch: {},
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
